import { Read, Create, Update, Delete } from '@/constants/permission-rights';

export default class Permission {
	constructor(permissionId, permissionRight) {
		//initialize crud props
		this[Read] = false;
		this[Create] = false;
		this[Update] = false;
		this[Delete] = false;
		this.permissionId = permissionId;
		//set the passed in crud prop
		this[permissionRight] = true;
	}

	//takes in a permission and checks it against this instance of the permission
	checkPermission(userPermission) {
		let result = false;

		result = this.permissionId == userPermission.permissionId;

		//if this instance requires the permission, check that the userPermission has it
		if (this[Read]) {
			result = result && userPermission.permission === Read;
		}

		if (this[Create]) {
			result = result && userPermission.permission === Create;
		}

		if (this[Update]) {
			result = result && userPermission.permission === Update;
		}

		if (this[Delete]) {
			result = result && userPermission.permission === Delete;
		}

		return result;
	}
}
